export default {
  // Default stays prod; set REACT_APP_API_URL in .env.local to point a local
  // dev server at a local strongbody-api (chat-server tokens must come from the
  // same environment as CHAT_SERVER_ENDPOINT below).
  API_URL: process.env.REACT_APP_API_URL || 'https://api-v2.strongbody.ai',
  // API_URL: 'http://localhost:8000',
  // API_URL: 'https://api-v2.strongbody.ai',
  // API_URL: 'http://localhost:8000',
  // API_URL: 'https://api-v2.strongbody.ai',
  // API_URL: 'https://api-v2.strongbody.ai',
  WEB_URL: process.env.REACT_APP_WEB_URL,
  // Endpoint web dùng riêng cho LINK HỒ SƠ SELLER (/app/seller, /app/users).
  // Tách khỏi WEB_URL vì hồ sơ seller đang chạy ở một deployment khác với
  // trang product/service/blog. Bỏ trống -> dùng mặc định trong utils/urls.js.
  SELLER_WEB_URL: process.env.REACT_APP_SELLER_WEB_URL,
  POINT_API_URL: process.env.REACT_APP_POINT_API_URL,
  VOICE_API_URL: process.env.REACT_APP_VOICE_API_URL,

  VOICEHUB_URL: process.env.REACT_APP_VOICEHUB_URL,
  // chat-server (thay PubNub). Token do strongbody-api cấp phải cùng môi trường
  // với endpoint này — token của api-v2 (prod) chỉ dùng được với chat.strongbody.ai.
  CHAT_SERVER_ENDPOINT:
    process.env.REACT_APP_CHAT_SERVER_ENDPOINT || 'wss://chat.strongbody.ai',
  CHAT_SERVER_TENANT:
    process.env.REACT_APP_CHAT_SERVER_TENANT || 'strongbody',
};
